import { RouteRecordRaw } from 'vue-router'
import { computed, ComputedRef } from 'vue'
import store from '@/store'
import { RouteList } from '@/routes/RouteList'
import { FeatureEnum } from '@/enums/FeatureEnum'
import router from '@/routes'

const AcademyView = () => import('@/views/Academy/AcademyView.vue')

const businessSlug: ComputedRef<string> = computed(
  () => store.getters['BusinessModule/businessSlug']
)

export default <RouteRecordRaw[]>[
  {
    path: RouteList.LEARNING.ACADEMY_REDIRECT.PATH,
    name: RouteList.LEARNING.ACADEMY_REDIRECT.NAME,
    redirect: () => {
      const route = {
        name: RouteList.LEARNING.LEARN.NAME,
        params: { businessSlug: businessSlug.value }
      }

      window.open(import.meta.env.VITE_APP_BASE_URL + router.resolve(route).href, '_blank')
      return ''
    },
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      feature: [FeatureEnum.LEARNING, FeatureEnum.LEARNING_ACADEMY]
    }
  },
  {
    path: RouteList.LEARNING.LEARN.PATH,
    name: RouteList.LEARNING.LEARN.NAME,
    components: {
      default: AcademyView
    },
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      feature: [FeatureEnum.LEARNING, FeatureEnum.LEARNING_ACADEMY]
    }
  },
  {
    path: RouteList.LEARNING.HELP_CENTER.PATH,
    name: RouteList.LEARNING.HELP_CENTER.NAME,
    redirect: () => {
      window.open(import.meta.env.VITE_EXTERNAL_IKS_HELP_CENTER, '_blank')
      return ''
    },
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      feature: [FeatureEnum.LEARNING, FeatureEnum.LEARNING_HELP_CENTER]
    }
  }
]
